export default __webpack_public_path__ + "static/21-b9dfbf1a11868986940ad05cfbdaa1ac.jpg";